import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-line" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("a", {
      class: "line-icon",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.lineWindow && _ctx.lineWindow(...args)))
    }, _hoisted_2)
  ]))
}